import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85bf24d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Next ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      as: "el-form",
      "validation-schema": _ctx.schema,
      validate: "true"
    }, {
      default: _withCtx(({errors}) => [
        _createVNode(_component_app_input, {
          clearable: "",
          modelValue: _ctx.nurseFieldValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nurseFieldValue) = $event)),
          name: "nurseField",
          label: "Field of work",
          placeholder: "Field of work"
        }, {
          "label-append": _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_app_button, {
          onClick: _ctx.nextStep,
          disabled: !_ctx.nurseFieldValue || !!errors.nurseField,
          type: "primary",
          "native-type": "submit",
          class: "w-100 el-button-lg",
          round: ""
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 2
        }, 1032, ["onClick", "disabled"])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ]))
}